"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";
import GroupCardActionFooter from "./utils/GroupCardActionFooter";
import { ApiRateMatter } from "@/generated/models/ApiRateMatter";
export default function GroupCardActionWrapper(t0) {
  const $ = _c(26);
  const {
    loading,
    disabled,
    addingRates,
    doneMembersCount,
    membersCount,
    matter,
    onSave,
    onCancel,
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      [ApiRateMatter.Rep]: "Rep",
      [ApiRateMatter.Cic]: "NIC"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const MATTER_LABEL = t1;
  let t2;
  if ($[1] !== doneMembersCount || $[2] !== membersCount) {
    t2 = () => {
      if (typeof membersCount !== "number" || typeof doneMembersCount !== "number") {
        return "0%";
      }
      return `${doneMembersCount / membersCount * 100}%`;
    };
    $[1] = doneMembersCount;
    $[2] = membersCount;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const getProgress = t2;
  const [progress, setProgress] = useState(getProgress());
  let t3;
  if ($[4] !== getProgress) {
    t3 = () => {
      setProgress(getProgress());
    };
    $[4] = getProgress;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== doneMembersCount || $[7] !== membersCount) {
    t4 = [membersCount, doneMembersCount];
    $[6] = doneMembersCount;
    $[7] = membersCount;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  useEffect(t3, t4);
  let t5;
  if ($[9] !== addingRates || $[10] !== children || $[11] !== doneMembersCount || $[12] !== matter || $[13] !== membersCount || $[14] !== progress) {
    t5 = addingRates ? <div className="tw-space-y-4"><div><p className="tw-mb-0 tw-text-base tw-font-semibold tw-text-iron-50">{MATTER_LABEL[matter]} Progress</p><p className="tw-mt-1 tw-text-sm tw-text-iron-300">Keep this window open while we distribute credits across the group.</p></div><p className="tw-mb-0 tw-text-xl tw-font-bold tw-text-primary-400">{doneMembersCount}/{membersCount}</p><div className="tw-h-3 tw-w-full tw-overflow-hidden tw-rounded-full tw-bg-white/5"><div className="tw-h-3 tw-rounded-full tw-bg-primary-400" style={{
          width: progress,
          transition: "width 0.5s ease-out"
        }} /></div></div> : children;
    $[9] = addingRates;
    $[10] = children;
    $[11] = doneMembersCount;
    $[12] = matter;
    $[13] = membersCount;
    $[14] = progress;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t5) {
    t6 = <div className="tw-flex-1">{t5}</div>;
    $[16] = t5;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== disabled || $[19] !== loading || $[20] !== onCancel || $[21] !== onSave) {
    t7 = <GroupCardActionFooter onCancel={onCancel} loading={loading} disabled={disabled} onSave={onSave} />;
    $[18] = disabled;
    $[19] = loading;
    $[20] = onCancel;
    $[21] = onSave;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  let t8;
  if ($[23] !== t6 || $[24] !== t7) {
    t8 = <div className="tw-flex tw-h-full tw-flex-col tw-gap-y-5 tw-px-4 tw-py-5 sm:tw-px-5 sm:tw-py-6">{t6}{t7}</div>;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  return t8;
}